import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { api } from "@/context/AuthContext";
import { Kicker, MaskedLine, Reveal } from "@/components/Motion";

export default function Notices() {
  const [notices, setNotices] = useState(null);

  useEffect(() => {
    api
      .get("/notices")
      .then((r) => setNotices(r.data))
      .catch(() => setNotices([]));
  }, []);

  return (
    <div data-testid="notices-page">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <Kicker>Notices & News</Kicker>
          <h1 className="mt-4 font-display font-bold tracking-tight text-slate-900">
            <MaskedLine delay={0.1} className="text-4xl sm:text-5xl">
              Announcements board
            </MaskedLine>
          </h1>
          <Reveal delay={0.25} className="mt-4 max-w-2xl">
            <p className="text-base leading-relaxed text-slate-700">
              Camps, drives, new batches and schedule changes from NUC Service — National Union
              Corporation.
            </p>
          </Reveal>
        </div>
      </header>

      <section className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8" data-testid="notices-board">
        {notices === null && (
          <div className="space-y-4" data-testid="notices-loading">
            {[0, 1, 2].map((i) => (
              <div key={i} className="h-28 animate-pulse rounded-xl border border-slate-200 bg-white" />
            ))}
          </div>
        )}

        {notices !== null && notices.length === 0 && (
          <div className="rounded-xl border border-slate-200 bg-white p-10 text-center shadow-sm" data-testid="notices-empty">
            <Megaphone className="mx-auto h-8 w-8 text-slate-300" aria-hidden="true" />
            <p className="mt-4 text-slate-600">No active notices right now. Check back soon.</p>
          </div>
        )}

        <div className="space-y-5">
          {notices !== null &&
            notices.map((n, i) => (
              <Reveal key={n.id} delay={i * 0.05}>
                <article
                  data-testid={`notice-${n.id}`}
                  className={`rounded-xl border bg-white p-6 shadow-sm sm:p-8 ${
                    n.important ? "border-l-4 border-l-amber-500 border-slate-200" : "border-slate-200"
                  }`}
                >
                  <div className="flex flex-wrap items-center gap-3">
                    {n.important && (
                      <span className="rounded-full bg-amber-100 px-2.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider text-amber-800">
                        Important
                      </span>
                    )}
                    <span className="rounded-full bg-blue-50 px-2.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider text-blue-900">
                      {n.tag}
                    </span>
                    <time className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">
                      {n.date}
                    </time>
                  </div>
                  <h2 className="mt-3 font-display text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl">
                    {n.title}
                  </h2>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600 sm:text-base">{n.body}</p>
                  <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-400">
                    REF {n.id}
                  </p>
                </article>
              </Reveal>
            ))}
        </div>
      </section>
    </div>
  );
}
